import { render } from "./Page.vue?vue&type=template&id=debf3dec"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import "./Page.vue?vue&type=style&index=0&id=debf3dec&lang=scss"
script.render = render

export default script